<template>
    <v-card class="fill-width" tile color="light-blue lighten-4">
        <v-overlay :value="dLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <template>
            <v-row>
                <v-col cols="3">
                    <v-card>
                        <v-img src="@/assets/images/fondo1.png" height="160px">
                            <v-row align="center" justify="center"><v-card-title class="white--text"><div class="headline">Matricula</div></v-card-title></v-row>
                            <v-row justify="space-around">
                                <v-avatar size="90">
                                    <img src="@/assets/images/user1.jpg" alt="Postulante">
                                </v-avatar>
                            </v-row>
                        </v-img>
                        <v-list two-line>
                            <v-list-item>
                                <v-list-item-icon><v-icon>person</v-icon></v-list-item-icon>
                                <v-list-item-content><v-list-item-subtitle>{{dPriAlumno.Alumno}}</v-list-item-subtitle><v-list-item-subtitle>Apelidos y Nombres</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-icon><v-icon>bookmark</v-icon></v-list-item-icon>
                                <v-list-item-content><v-list-item-title>{{dServicio}}</v-list-item-title><v-list-item-subtitle>Programa de Estudios</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-icon><v-icon>qr_code_2</v-icon></v-list-item-icon>
                                <v-list-item-content><v-list-item-title><v-chip color="success" dark>{{dPriAlumno.Codigo}}</v-chip></v-list-item-title><v-list-item-subtitle>Codigo</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-col>
                <v-col cols="9">
                    <v-toolbar color="blue-grey darken-2" dark>
                        <v-icon>date_range</v-icon>
                        <v-spacer />
                        <v-icon class="red--text">date_range</v-icon>
                        <v-toolbar-title v-if="dPeriodoLast" class="red--text"> Ultimo Periodo: {{dPeriodoLast}}</v-toolbar-title>
                    </v-toolbar>
                    <v-form ref="refMain" class="pa-2 white">
                        <v-alert v-if="dMatriculaVigente" type="error" border="left">
                            <h3>NO PUEDE MATRICULARSE, Tiene matricula vigente 
                                {{dMatMatriculaLast.matseccion.matperiodo.Anio}}-
                                {{dMatMatriculaLast.matseccion.matperiodo.Periodo}} 
                                {{dMatMatriculaLast.matseccion.matperiodo.Nivel}}°
                                {{dMatMatriculaLast.matseccion.Seccion}}
                                que finaliza el {{dMatMatriculaLast.matseccion.FechaFin.substr(0,10)}}</h3>
                        </v-alert>
                        <template v-if="dIngPagoPeriodicoMatriculas.length != 0">
                            <v-alert type="error" border="left">
                                <h3>NO PUEDE MATRICULARSE, Tiene las siguientes deudas:</h3>
                            </v-alert>
                            <v-simple-table dense>
                                <template>
                                    <thead>
                                        <tr>
                                            <th class="text-center">Fecha</th>
                                            <th class="text-center">Deuda</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in dIngPagoPeriodicoMatriculas" :key="item.FechaDeuda">
                                            <td class="text-center">{{ item.FechaDeuda.substr(0,10) }}</td>
                                            <td class="text-center">s/. {{ item.Deuda }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </template>
                        <v-alert v-if="parseInt(dDesaprobadosNroCursos) > parseInt(dMaxDesaprobados)" type="error" border="left">
                            <h3>NO PUEDE MATRICULARSE, Tiene {{dDesaprobadosNroCursos}} cursos desaprobados en su ultima matricula, los cuales excede al número permitido de desaprobados {{dMaxDesaprobados}}</h3>
                        </v-alert>
                        <v-alert v-if="dDesaprobados.length > parseInt(dMaxDesaprobadosTotal)" type="error" border="left">
                            <h3>NO PUEDE MATRICULARSE, Tiene {{dDesaprobados.length}} cursos desaprobados en total, los cuales excede al número permitido de desaprobados {{dMaxDesaprobadosTotal}}</h3>
                        </v-alert>
                        <v-alert v-if="dSecciones.length == 0" type="error" border="left">
                            <h3>NO PUEDE MATRICULARSE, No hay secciones para seleccionar</h3>
                        </v-alert>
                        <v-row v-else>
                            <v-col cols="12" xm="12" sm="12" md="6" class="pa-1">
                                <v-select v-model="dIdSeccion" label="Sección" :items="dSecciones" item-value="IdSeccion" item-text="Seccion" :disabled="dIsUpdating" filled prepend-inner-icon="label" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                            </v-col>
                            <v-col cols="12" xm="12" sm="12" md="6" class="pa-1">
                                <v-select v-model="dCondicionMat" label="Tipo Matricula"
                                    :items="dMatriculaTipos" :disabled="dIsUpdating" item-value="MatriculaTipo" item-text="MatriculaTipo"
                                    filled prepend-inner-icon="local_offer" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                            </v-col>
                        </v-row>
                    </v-form>
                    <template v-if="dIngCronogramaPagos.length != 0">
                        <v-simple-table dense>
                            <template>
                                <thead>
                                    <tr style="background: #2196F3">
                                        <th class="text-center">MES</th>
                                        <th class="text-center">MONTO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="dMatMatriculaLast.matseccion.matperiodo.Nivel==0">
                                        <td class="text-center">Derecho de Inscripción</td>
                                        <td class="text-center">s/. 50</td>
                                    </tr>
                                    <tr v-for="item in dIngCronogramaPagos" :key="item.IdMes" style="border-bottom:2pt solid black;">
                                        <td class="text-center">{{fuMes(item.IdMes)}}</td>
                                        <td class="text-center">s/. {{ item.Monto }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </template>
                    <v-divider></v-divider>
                    <v-card-actions class="blue-grey darken-2">
                        <v-btn v-if="cIsValidated" @click.prevent="fuMatriculaSave" :loading="dIsUpdating" color="primary"><v-icon left>save</v-icon> Matricular</v-btn> 
                        <v-spacer />
                        <v-btn @click.prevent="buGoto"><v-icon left>arrow_back</v-icon> Atras</v-btn>
                    </v-card-actions>
                    <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
                        <v-btn text @click="dSnackbar = false"> Close</v-btn>
                    </v-snackbar>
                </v-col>
            </v-row>
        </template>
    </v-card>
</template>

<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';

export default {
    name: 'AlumnoFichaInscripc',
    mounted(){
        this.fuLoad(parseInt(this.$route.params.pIdAlumno));
        this.dPriAlumno.IdAlumno=this.$route.params.pIdAlumno;

        if (typeof this.$route.params.pUrl != "undefined"){
            this.dUrl= this.$route.params.pUrl.replace(/_/g,"/");
        }
        if(this.ssUser) this.dOperador=this.ssUser.Usuario;
    },
    data: () => ({
        dCondicionMat: 'REGULAR',
        dIsUpdating: false,
        dLoading: false,
        dIngPagoPeriodicoMatriculas: [],
        dMatMatriculaLast: {
            IdMatricula: '',
            matseccion: {
                Seccion: '',
                FechaFin: '',
                matperiodo: {
                    Periodo: '',
                    Anio: '',
                    Nivel: 0
                }
            }
        },
        dMatriculaVigente: false,
        dMatriculaTipos: [],
        dDesaprobados: [],
        dDesaprobadosNroCursos:0,
        dMaxDesaprobados: 0,
        dMaxDesaprobadosTotal: 0,
        dOperador: 'web',
        dPeriodoAMatricular: '',
        dPeriodoLast: '',
        dPriAlumno: {
            IdAlumno: '',
            Alumno: '',
            Codigo: '',
        },
        dServicio: '',
        dSecciones: [],
        dIdSeccion: null,
        dSnackbar: false,
        dIngCronogramaPagos: [],
        dUrl:''
    }),
    methods: {
        buGoto(){
            if(this.dUrl)
                window.location = this.dUrl;
            else
                this.$router.push(`/`);
        },
        async fuLoad(pIdAlumno) {
            this.dLoading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query matriculaPrev($IdAlumno: ID!){
                            prialumno(IdAlumno: $IdAlumno){
                                Alumno
                                Codigo
                                priservicio{
                                    Iniciales
                                }
                            }
                            matmatriculaLast(IdAlumno: $IdAlumno){
                                IdMatricula
                                matseccion{
                                    Seccion
                                    FechaFin
                                    matperiodo{
                                        Periodo
                                        Anio
                                        Nivel
                                    }
                                }    
                            }
                            matconfig{
                                maxDesaprobados
                                maxDesaprobadosTotal
                            }
                            matcursoNroCursosDesaprobados(IdAlumno:$IdAlumno){
                                success
                                message
                                data
                            }
                            dcbnotafinalDesaprobados(IdAlumno:$IdAlumno){
                                IdNotaFinal
                                IdCursoCurricula
                                PromedioFinal
                            }
                            ingpagoperiodicomatriculaDeudaAll(IdAlumno:$IdAlumno){
                                IdMatricula
                                FechaDeuda
                                Monto
                                Dsctpp
                                Deuda
                            }
                            matseccionAMatricular(IdAlumno: $IdAlumno){
                                IdSeccion
                                Seccion
                                Turno
                                FechaInicio
                                HoraTurno
                                matperiodo{
                                    Anio
                                    Periodo
                                    Nivel
                                }
                                ingcronogramapagos{
                                    IdMes
                                    FechaDeuda
                                    Monto
                                }
                            }
                            matmatriculatipoByactivoByisWeb(activo:1, isWeb:true){
                                MatriculaTipo
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: pIdAlumno
                    }
                })
                this.dPriAlumno.Alumno = response.data.prialumno.Alumno;
                this.dPriAlumno.Codigo = response.data.prialumno.Codigo;
                this.dServicio = response.data.prialumno.priservicio.Iniciales;

                this.dMaxDesaprobados=response.data.matconfig[0].maxDesaprobados;
                this.dMaxDesaprobadosTotal=response.data.matconfig[0].maxDesaprobadosTotal;
                this.dDesaprobadosNroCursos=response.data.matcursoNroCursosDesaprobados.data;
                this.dDesaprobados=response.data.dcbnotafinalDesaprobados;

                this.dMatriculaTipos=response.data.matmatriculatipoByactivoByisWeb;

                if(response.data.matseccionAMatricular.length>0){
                    if(response.data.matmatriculaLast[0]){
                        this.dMatMatriculaLast = response.data.matmatriculaLast[0];
                        this.fuMatriculaVigente();

                        let vYears = [];
                        let vYear = response.data.matseccionAMatricular[0].matperiodo.Anio;
                        this.dPeriodoLast = response.data.matmatriculaLast[0].matseccion.matperiodo.Anio +'-'+ response.data.matmatriculaLast[0].matseccion.matperiodo.Periodo;

                        for (var i = vYear; i >= vYear-10; i--) {
                            vYears.push(i+'-2');
                            vYears.push(i+'-1');
                        }
                    }
                }

                this.dIngPagoPeriodicoMatriculas = response.data.ingpagoperiodicomatriculaDeudaAll;

                this.dSecciones = response.data.matseccionAMatricular.map(item =>{
                    var vTurno = 'Mañana';
                    if(item.Turno=='T')
                        vTurno = 'Tarde';
                    else if(item.Turno=="N")
                        vTurno = 'Noche';
                    else if(item.Turno=="M")
                        vTurno = 'Mañana';
                    else
                        vTurno = item.Turno;
                    return {
                        IdSeccion: item.IdSeccion,
                        Seccion: item.matperiodo.Nivel+"° "+ item.Seccion +" "+ item.matperiodo.Anio +"-"+ item.matperiodo.Periodo +" "+ vTurno +" - "+item.HoraTurno +" - Fecha de Inicio: " + item.FechaInicio.substr(0, 10),
                        ingcronogramapagos: item.ingcronogramapagos
                    };
                });
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema al validar Matricula.', 'error');
            } finally {
                this.dLoading = false;
            }
        },
        fuMatriculaSave () {
            if(this.dMatriculaVigente || this.dIngPagoPeriodicoMatriculas.length != 0 || (parseInt(this.dDesaprobadosNroCursos) > parseInt(this.dMaxDesaprobados)) || (this.dDesaprobados.length > parseInt(this.dMaxDesaprobadosTotal)) || (this.dSecciones.length == 0))
                Swal.fire('¡ ERROR !', 'No puede registrar su matricula, no cumple con las restricciones.', 'error');
            else{
                this.fuMatriculaCreate();
            }
        },
        async fuMatriculaCreate () {
            if(!this.$refs.refMain.validate()){
                this.dSnackbar = true;
            } else {
                try {
                    this.dIsUpdating = true;
                    const response = await this.$apollo.mutate({
                        mutation: gql`mutation matmatriculaSpMATRICULAS(
                            $IdSeccion: String,
                            $IdAlumno: String,
                            $FechaMatricula: String,
                            $IdCurricula: String,
                            $Observacion: String,
                            $Grupo: String,
                            $Condicion: String,
                            $CondicionMat: String,
                            $Operador: String,
                            $Accion: String,
                        ){
                            matmatriculaSpMATRICULAS(
                                IdSeccion: $IdSeccion,
                                IdAlumno: $IdAlumno,
                                FechaMatricula: $FechaMatricula,
                                IdCurricula: $IdCurricula,
                                Observacion: $Observacion,
                                Grupo: $Grupo,
                                Condicion: $Condicion,
                                CondicionMat: $CondicionMat,
                                Operador: $Operador,
                                Accion: $Accion
                            ){
                                success
                                message
                            }
                        }`,
                        variables: {
                            IdSeccion : this.dIdSeccion,
                            IdAlumno : this.$route.params.pIdAlumno,
                            FechaMatricula : moment().format("YYYYMMDD HH:mm:ss"),
                            IdCurricula : "0",
                            Observacion : "",
                            Grupo : "1",
                            Condicion : "REGULAR",
                            CondicionMat : this.dCondicionMat,
                            Operador : this.dOperador,
                            Accion : "A"
                        }
                    });
                    if(response.data.matmatriculaSpMATRICULAS.success==1){
                        console.log("Se guardó el alumno");
                        Swal.fire({
                            title: 'Su matricula se registro',
                            html: '<div style="text-align:left;">Apersonarse a Caja Cusco para pagar.</div>',
                            confirmButtonText: 'Continuar',
                            allowOutsideClick: false,
                            imageUrl: './img/cajaCusco.png',
                            imageWidth: 400,
                            imageHeight: 130,
                            imageAlt: 'Caja Cusco',
                            showLoaderOnConfirm: true,
                        }).then((result) => {
                            //window.location = 'https://khipu.edu.pe/';
                            //window.location = 'https://khipu.plus/crm';
                            //this.buGoto();
                            this.$router.push(`/AlumnoItem/${this.$route.params.pIdAlumno}`);
                        })
                    } else {
                        console.log("No se guardo la matricula.");
                        Swal.fire('¡ ERROR !', response.data.matmatriculaSpMATRICULAS.message, 'error');
                    }
                } catch (error) {
                    console.log(error);
                    Swal.fire('¡ ERROR !', 'No se guardó la matricula.', 'error');
                } finally {
                    this.dIsUpdating = false;
                }
            }
        },
        fuMes(pIdMes){
            switch (pIdMes) {
                case 0: return 'MATRICULA'; break;
                case 1: return 'ENERO'; break;
                case 2: return 'FEBRERO'; break;
                case 3: return 'MARZO'; break;
                case 4: return 'ABRIL'; break;
                case 5: return 'MAYO'; break;
                case 6: return 'JUNIO'; break;
                case 7: return 'JULIO'; break;
                case 8: return 'AGOSTO'; break;
                case 9: return 'SEPTIEMBRE'; break;
                case 10: return 'OCTUBRE'; break;
                case 11: return 'NOVIEMBRE'; break;
                case 12: return 'DICIEMBRE'; break;
            }
        },
        fuMatriculaVigente(){
            let hoy = moment().format("YYYYMMDD");
            let FechaFin = moment(this.dMatMatriculaLast.matseccion.FechaFin).format("YYYYMMDD");

            if(FechaFin<hoy)
                this.dMatriculaVigente=false;
            else
                this.dMatriculaVigente=true;
        }
    },
    watch: {
        dIdSeccion (val) {
            this.dSecciones.forEach((item) => {
                if(item.IdSeccion == val){
                    this.dIngCronogramaPagos = item.ingcronogramapagos;
                }
            })
        }
    },
    computed: {
        ...mapState(['ssUser']),
        cIsValidated: function () {
            if(this.dMatriculaVigente || this.dIngPagoPeriodicoMatriculas.length != 0 || (parseInt(this.dDesaprobadosNroCursos) > parseInt(this.dMaxDesaprobados)) || (this.dDesaprobados.length > parseInt(this.dMaxDesaprobadosTotal)) || (this.dSecciones.length == 0))
                return false;
            else
                return true;
        }
    }
}
</script>